export function bearingBetween(from, to) {
    if (!from || !to) {
        return null
    }

    const lat1 = Number(from.latitude)
    const lng1 = Number(from.longitude)
    const lat2 = Number(to.latitude)
    const lng2 = Number(to.longitude)

    if (![lat1, lng1, lat2, lng2].every(Number.isFinite)) {
        return null
    }

    const phi1 = lat1 * Math.PI / 180
    const phi2 = lat2 * Math.PI / 180
    const deltaLambda = (lng2 - lng1) * Math.PI / 180
    const y = Math.sin(deltaLambda) * Math.cos(phi2)
    const x = Math.cos(phi1) * Math.sin(phi2) - Math.sin(phi1) * Math.cos(phi2) * Math.cos(deltaLambda)

    return ((Math.atan2(y, x) * 180 / Math.PI) + 360) % 360
}

/** Bearing of the outgoing segment (current → next), or incoming on last point. */
export function segmentBearingAtPoint(points, index) {
    if (!Array.isArray(points) || index == null || index < 0) {
        return null
    }

    if (index < points.length - 1) {
        return bearingBetween(points[index], points[index + 1])
    }

    if (index > 0) {
        return bearingBetween(points[index - 1], points[index])
    }

    return null
}
